import { MDBPopoverBody } from 'mdb-react-ui-kit'
import React from 'react'
import LanguageButton from '../LanguageButton/LanguageButton'

function HeaderLangButtons({ trads, changeLanguage }) {
  
  const pathAfterLang = changeLanguage // changeLanguage es la URL completa actual
    .replace(/^https?:\/\/[^\/]+\/(es|eu)\//, '') // Extrae solo la parte después del idioma
    .replace(/^\/+/, '') // Quita TODOS los slashes iniciales

  return (
    <MDBPopoverBody tag="div">
      <span>
        <LanguageButton
          link={`/es${pathAfterLang ? '/' + pathAfterLang : ''}`}
          title={trads.castellano}
          text="ES"
        />
        <hr className="horizontalSeparator" />
      </span>
      <span>
        <LanguageButton
          link={`/eu${pathAfterLang ? '/' + pathAfterLang : ''}`}
          title="Euskera"
          text="EU"
        />
      </span>
    </MDBPopoverBody>
  )
}


export default HeaderLangButtons
